export default __webpack_public_path__ + "static/project-start1-09d8827c2d63a6299ae67ba99aef7bc0.png";